import { render, staticRenderFns } from "./PriceControlEdit.vue?vue&type=template&id=694f6ce4&"
import script from "./PriceControlEdit.vue?vue&type=script&lang=js&"
export * from "./PriceControlEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports